<template>
    <v-container fluid v-if="tiene_empresa">
        <!-- VENTANA PARA PODER VER, CREAR O ACTUALIZAR UN CLIENTE -->
        <v-dialog v-model="estado_dialog" width="1000" persistent scrollable>
            <v-card>
                <v-card-title>
                    <v-checkbox v-model="cliente_x" :label="$t('customer-dialog-checkbox1')" dense
                        hide-details></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-checkbox v-model="cliente_activo" :label="$t('customer-dialog-checkbox2')" dense
                        hide-details></v-checkbox>

                    {{ estadoCliente }}
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <!-- FECHA, TIPO DOC, CODIGO, NOMBRE ... -->
                        <v-row class="my-1">
                            <v-col cols="12">
                                <v-card class="mx-3" elevation="0" style="border: 1px solid black" outlined>

                                    <v-tabs v-model="activeTab" background-color="primary accent-4" center-active dark>
                                        <v-tab>Cliente</v-tab>
                                        <v-tab v-if="canContratos">Contratos</v-tab>
                                    </v-tabs>

                                    <v-tabs-items v-model="activeTab">
                                        <!-- CLIENTE -->
                                        <v-tab-item>
                                            <v-card-text>
                                                <v-row dense>
                                                    <v-col cols="12" md="6" class="pa-1">
                                                        <v-text-field v-model="fecha_ingreso"
                                                            :label="$t('customer-dialog-input-label1')" outlined dense
                                                            hide-details type="date"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="6" class="pa-1">
                                                        <v-autocomplete v-model="id_tipo_doc_fiscal"
                                                            :items="items_tipo_doc_fiscal" item-text="nombre"
                                                            item-value="id_tipo_doc_fiscal"
                                                            :label="$t('customer-dialog-input-label2')" outlined dense
                                                            hide-details :error="errorTipoDocFiscal"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-text-field v-model="codigo"
                                                            :label="$t('customer-dialog-input-label3')" outlined dense
                                                            hide-details :error="errorCodigo"
                                                            :readonly="flag_nuevo_edit === 2"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="pa-1">
                                                        <v-text-field v-model="nombre"
                                                            :label="$t('customer-dialog-input-label4')" outlined dense
                                                            hide-details :error="errorNombre"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="pa-1">
                                                        <v-text-field v-model="razon_social"
                                                            :label="$t('customer-dialog-input-label5')" outlined dense
                                                            hide-details :error="errorRazonSocial"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="6" class="pa-1">
                                                        <v-autocomplete v-model="id_departamento"
                                                            :items="items_departamento" item-text="nombre"
                                                            item-value="id_departamento"
                                                            :label="$t('customer-dialog-input-label6')" outlined dense
                                                            hide-details @input="listarMunicipios(id_departamento)"
                                                            :error="errorDepartamento"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="6" class="pa-1">
                                                        <v-autocomplete v-model="id_municipio" :items="items_municipio"
                                                            item-text="nombre" item-value="id_municipio"
                                                            :label="$t('customer-dialog-input-label7')" outlined dense
                                                            hide-details :error="errorMunicipio"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" class="pa-1">
                                                        <v-text-field v-model="direccion"
                                                            :label="$t('customer-dialog-input-label8')" outlined dense
                                                            hide-details :error="errorDireccion"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="8" class="pa-1">
                                                        <v-autocomplete v-model="id_actividad_economica"
                                                            :items="items_actividad_economica"
                                                            item-value="id_actividad_economica" item-text="nombre"
                                                            :label="$t('customer-dialog-input-label9')" outlined dense
                                                            hide-details :error="errorActividadEconomica">
                                                            <template v-slot:selection="data">
                                                                {{ data.item.cod_MH.trim() }} {{ data.item.nombre }}
                                                            </template>
                                                            <template v-slot:item="data">
                                                                {{ data.item.cod_MH.trim() }} {{ data.item.nombre }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-autocomplete v-model="tamaño" :items="items_tamaño"
                                                            :label="$t('customer-dialog-input-label10')" outlined dense
                                                            hide-details :error="errorTamaño"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-text-field v-model="registro"
                                                            :label="$t('customer-dialog-input-label11')" outlined dense
                                                            hide-details :error="errorRegistro"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-text-field v-model="email_1"
                                                            :label="$t('customer-dialog-input-label12')" outlined dense
                                                            hide-details :error="errorEmail1"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-text-field v-model="email_2"
                                                            :label="$t('customer-dialog-input-label13')" outlined dense
                                                            hide-details></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="8" class="pa-1">
                                                        <v-text-field v-model="contacto"
                                                            :label="$t('customer-dialog-input-label14')" outlined dense
                                                            hide-details></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-text-field v-model="telefono"
                                                            :label="$t('customer-dialog-input-label15')" outlined dense
                                                            hide-details :error="errorTelefono"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-autocomplete v-model="tipo_persona"
                                                            :items="items_tipo_persona"
                                                            :label="$t('customer-dialog-input-label16')" outlined dense
                                                            hide-details :error="errorTipoPersona"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-autocomplete v-model="id_identificador"
                                                            :items="items_identificador" item-text="nombre"
                                                            item-value="id_identificador"
                                                            :label="$t('customer-dialog-input-label17')" outlined dense
                                                            hide-details :error="errorIdentificador"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="4" class="pa-1">
                                                        <v-text-field v-model="documento"
                                                            :label="$t('customer-dialog-input-label18')" outlined dense
                                                            hide-details :error="errorDocumento"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-card>
                            </v-col>
                        </v-row>
                        <!-- CHECKBOX ... -->
                        <v-row no-gutters class="my-1">
                            <v-col cols="12">
                                <v-card class="mx-3" elevation="0" outlined style="border: 1px solid black">
                                    <v-card-text>
                                        <v-row justify="center">
                                            <v-col cols="12" md="auto">
                                                <v-checkbox v-model="con_retencion"
                                                    :label="$t('customer-dialog-checkbox3')" dense hide-details
                                                    @change="estadoRetencion()"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="auto">
                                                <v-checkbox v-model="con_percepcion"
                                                    :label="$t('customer-dialog-checkbox4')" dense hide-details
                                                    @change="estadoPercepcion()"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="auto">
                                                <v-checkbox v-model="exento" :label="$t('customer-dialog-checkbox5')"
                                                    dense hide-details @click="seleccionExento()"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" md="6" align-self="center" v-if="false">
                                <v-card class="mx-3" elevation="3">
                                    <v-card-text>
                                        <v-row no-gutters>
                                            <v-col cols="6">
                                                <v-checkbox v-model="con_credito" label="CON CREDITO" dense
                                                    hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox v-model="exede_credito" label="EXEDE CREDITO" dense
                                                    hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" class="pa-1">
                                                <v-text-field v-if="false" v-model="limite_credito"
                                                    label="Limite de credito" outlined dense hide-details
                                                    type="number"></v-text-field>
                                            </v-col>
                                            <v-col cols="6" class="pa-1">
                                                <v-text-field v-if="false" v-model="maximo_dias_limite"
                                                    label="Maximo días limite" outlined dense hide-details
                                                    type="number"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <!-- EXTRANJERO, TIPO EXPORT, ZONA, PAIS -->
                        <v-row no-gutters class="my-1">
                            <v-col cols="12">
                                <v-card class="mx-3" elevation="0" outlined style="border: 1px solid black">
                                    <v-card-text>
                                        <v-row no-gutters justify="space-between">
                                            <v-col cols="auto" md="3">
                                                <v-checkbox v-model="extranjero"
                                                    :label="$t('customer-dialog-checkbox6')" dense hide-details
                                                    @click="seleccionExtranjero()"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="5" class="pa-1">
                                                <v-autocomplete v-model="id_tipo_exportacion" :items="items_tipo_export"
                                                    item-text="nombre" item-value="id_tipo_exportacion"
                                                    :label="$t('customer-dialog-input-label19')" outlined dense
                                                    hide-details :error="errorTipoExportacion"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="auto" md="3">
                                                <v-checkbox v-model="es_zona_franca_dpa"
                                                    :label="$t('customer-dialog-checkbox7')" dense
                                                    hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="4" class="pa-1 mx-auto">
                                                <v-autocomplete v-model="id_pais" :items="items_paises"
                                                    item-text="nombre" item-value="id_pais"
                                                    :label="$t('customer-dialog-input-label20')" outlined dense
                                                    hide-details :error="errorPais"></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="crearCliente()" v-if="flag_nuevo_edit == 1">{{ $t("btn-save")
                        }}</v-btn>
                    <v-btn color="primary" @click="actualizarCliente()" v-if="flag_nuevo_edit == 2">{{ $t("btn-update")
                        }}</v-btn>
                    <v-btn color="red" dark @click="eliminarCliente()" v-if="flag_nuevo_edit == 2">{{ $t("btn-delete")
                        }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cerrarDialogCliente()">{{
                        $t("btn-close")
                        }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- VENTANA PARA MOSTRAR LOS PAISES -->
        <v-dialog v-model="dialog_paises" width="500">
            <v-data-table :headers="headers_paises" :items="items_paises" :search="search" @dblclick:row="setPais">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Países</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" label="BUSCAR" outlined dense hide-details></v-text-field>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">fa-solid fa-circle-info</v-icon>
                            </template>
                            <span>Doble click para seleccionar el país</span>
                        </v-tooltip>
                    </v-toolbar>
                </template>
            </v-data-table>
        </v-dialog>

        <v-dialog v-model="dialog_eliminar_contrato" width="500">
            <v-card>
                <v-card-title> ¿Esta seguro de eliminar este producto? </v-card-title>
                <v-card-actions>
                    <v-btn color="red" dark @click="eliminarContratoDetalle()">Eliminar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog_eliminar_contrato = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_eliminar_cliente" width="500" persistent>
            <v-card>
                <v-card-title>{{ $t("customer-message1") }} <br />
                    {{ nombre }}
                </v-card-title>
                <v-card-actions>
                    <v-btn color="red" dark @click="confirmarEliminarCliente()">{{
                        $t("btn-delete")
                        }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog_eliminar_cliente = !dialog_eliminar_cliente">{{ $t("btn-close")
                        }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar" timeout="-1" color="blue" multi-line elevation="24" outlined top right>
            <v-icon>{{ icon_snackbar }}</v-icon>
            {{ snackbar_text }}

            <template v-slot:action="{ attrs }">
                <v-btn icon v-bind="attrs" @click="snackbar = false">
                    <v-icon>fa-regular fa-circle-xmark</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from "axios";
import settings from "../settings/settings";


export default {
    props: [
        "estado_dialog", "estado_nuevo_editar_dialog", "errorDocumentoIdentificador"


    ],
    data: () => ({
        valid: true,
        snackbar: false,
        snackbar_text: "...",
        icon_snackbar: "fa-solid fa-circle-info",
        search_cliente: "",
        search: "",
        items: [],
        id_empresa: 0,
        //CLIENTE
        id_cliente: 0,
        fecha_ingreso: settings.metodos.formatoFecha(new Date()),
        id_tipo_doc_fiscal: "",
        items_tipo_doc_fiscal: [
            {
                id_tipo_doc_fiscal: 10,
                cod_doc_fiscal: "CCF",
                nombre: "COMPROBANTE DE CREDITO FISCAL",
                cod_MH: "03",
            },
            {
                id_tipo_doc_fiscal: 15,
                cod_doc_fiscal: "NRM",
                nombre: "NOTA DE REMISION",
                cod_MH: "04",
            },
            {
                id_tipo_doc_fiscal: 13,
                cod_doc_fiscal: "NCR",
                nombre: "NOTA DE CREDITO",
                cod_MH: "05",
            },
            {
                id_tipo_doc_fiscal: 11,
                cod_doc_fiscal: "FAC",
                nombre: "FACTURA DE CONSUMIDOR FINAL",
                cod_MH: "01",
            },
            {
                id_tipo_doc_fiscal: 12,
                cod_doc_fiscal: "FEX",
                nombre: "FACTURA DE EXPORTACION",
                cod_MH: "11",
            },
        ],
        codigo: "",
        nombre: "",
        razon_social: "",
        id_departamento: "",
        items_departamento: [],
        id_municipio: "",
        items_municipio: [],
        direccion: "",
        id_actividad_economica: "",
        items_actividad_economica: [],
        tamaño: "",
        items_tamaño: ["PEQUEÑO", "MEDIANO", "GRANDE", "OTROS"],
        registro: "",
        email_1: "",
        email_2: "",
        contacto: "",
        telefono: "",
        tipo_persona: "",
        items_tipo_persona: ["NATURAL", "JURIDICA"],
        id_identificador: "",
        items_identificador: [],
        documento: "",
        con_retencion: false,
        cliente_activo: true,
        cliente_x: false,
        exento: false,
        con_percepcion: false,
        con_credito: false,
        exede_credito: false,
        limite_credito: "",
        maximo_dias_limite: "",
        extranjero: false,
        id_tipo_exportacion: "",
        items_tipo_export: [],
        es_zona_franca_dpa: false,
        headers_paises: [
            { text: "Codigo", value: "cod_pais", align: "center" },
            { text: "Nombre", value: "nombre" },
        ],
        id_pais: "",
        items_paises: [],

        dialog_paises: false,
        flag_nuevo_edit: 1,

        //Contrato
        activeTab: 0,
        fecha_contrato: settings.metodos.formatoFecha(new Date()),
        codigo_bien: "",
        contrato_descripcion: "",
        monto_contrato: 0.00,
        cautelado_contrato: false,
        extingido_contrato: false,
        fecha_caducidad: settings.metodos.formatoFecha(new Date()),
        numero_contrato: "",
        contrato_activo: "",

        headers_contratos: [
            { text: "Fecha Inicio", value: "fecha_contrato", align: "center" },
            { text: "Fecha Caducidad", value: "fecha_caducidad", align: "center" },
            { text: "Número Contrato", value: "numero_contrato", align: "center" },
            { text: "Código del bien", value: "codigo_bien", align: "center" },
            { text: "Cautelado", value: "cautelado_contrato", align: "center" },
            { text: "Extinguido", value: "extingido_contrato", align: "center" },
            { text: "Activo", value: "contrato_activo", align: "center" },
            { text: "Descripción", value: "contrato_descripcion", align: "center" },
            { text: "Monto", value: "monto_contrato", align: "center" },
            { text: "Editar", value: "action_edit", align: "center" },
            { text: "NPE", value: "npe_contrato", align: "center" },
            { text: "Eliminar", value: "action_delete", align: "center" },
        ],

        items_contratos: [],
        dialog_eliminar_contrato: false,

        errorCodigo: false,
        errorNombre: false,
        errorRazonSocial: false,
        errorDepartamento: false,
        errorMunicipio: false,
        errorDireccion: false,
        errorActividadEconomica: false,
        errorTamaño: false,
        errorTelefono: false,
        errorTipoPersona: false,
        errorIdentificador: false,
        errorDocumento: false,
        errorTipoDocFiscal: false,
        errorPais: false,
        errorTipoExportacion: false,
        errorEmail1: false,
        errorEmail2: false,
        errorRegistro: false,
        dialog_eliminar_cliente: false,
        items_pacientes: [],
        paciente: "",

    }),
    created() { },
    watch: {
        cliente_x(val) {
            if (val) {
                this.obtenerDatosEmpresa(this.$store.state.emp.id_empresa);

                this.direccion = "SAN SALVADOR";
                this.telefono = "0000-0000";
                this.id_actividad_economica = 771;
                this.documento = "00000000-0";
                this.id_identificador = 2;
                this.tamaño = "OTROS";
                this.id_tipo_doc_fiscal = 11;

                this.id_departamento = 2;
                this.listarMunicipios(this.id_departamento).then(() => {
                    this.id_municipio = this.items_municipio.find(
                        (municipio) => municipio.nombre === "SAN SALVADOR"
                    ).id_municipio;
                });
            }
        },
        canContratos(val) {
            if (!val && this.activeTab !== 0) this.activeTab = 0;
        }
    },

    computed: {

        estadoCliente() {
            if (this.estado_nuevo_editar_dialog > 0) {
                this.listarClientes();
            }
        },

        tiene_empresa() {
            if (this.$store.state.emp) {
                this.listarClientes();
                this.listarDepartamentos();
                this.listarIdentificadores();
                this.listarTipoExportacion();
                this.listarActividadEconomica();
                this.listarPaises("nuevo");
                return true;
            } else {
                return false;
            }
        },

        canContratos() {
            const emp = this.$store.state.emp;
            return !!emp && Number(emp.id_empresa) === 55;
        },
        headerTable1() {
            return [
                { text: this.$t("customer-table-header-t1"), value: "codigo" },
                { text: this.$t("customer-table-header-t2"), value: "nombre" },
                { text: this.$t("customer-table-header-t3"), value: "registro" },
                {
                    text: this.$t("customer-table-header-t4"),
                    value: "identificador_nombre",
                },
                { text: this.$t("customer-table-header-t5"), value: "telefono" },
                { text: this.$t("customer-table-header-t6"), value: "tipo_persona" },
                {
                    text: this.$t("customer-table-header-t7"),
                    value: "cliente_activo",
                    align: "center",
                },
                {
                    text: this.$t("customer-table-header-t8"),
                    value: "action_edit",
                    sortable: false,
                },
            ];
        },

    },
    methods: {
        async obtenerDatosEmpresa(id_empresa) {
            try {
                const response = await axios.get(
                    `api/DetallesEmpresas/BusquedaEmpresa/${id_empresa}`
                );
                const datos = response.data[0];
                this.telefono = datos.telefono;
                this.email_1 = datos.correo;
            } catch (error) {
                console.error("Error al obtener los datos de la API", error);
            }
        },
        listarActividadEconomica() {
            axios.get("api/ActividadEconomicas/Listar").then((response) => {
                this.items_actividad_economica = response.data;
            });
        },
        listarClientes() {
            const emp = this.$store.state.emp;
            if (!emp || emp.id_empresa == null) return;

            axios
                .get("api/Clientes/Listar/" + emp.id_empresa) // ← URL corregida
                .then(({ data }) => {
                    // Valida la respuesta
                    if (!Array.isArray(data) || data.length === 0) {
                        this.items = [];
                        return;
                    }

                    this.items = data;

                    // Si estás editando, busca el cliente correspondiente
                    if (this.estado_nuevo_editar_dialog && this.estado_nuevo_editar_dialog > 0) {
                        const cliente = this.items.find(
                            c => Number(c.id_cliente) === Number(this.estado_nuevo_editar_dialog)
                        );
                        if (cliente) this.editarCliente(cliente);
                    }
                })
                .catch(() => {
                    this.items = [];
                });
        },
        nuevoCliente() {
            this.flag_nuevo_edit = 1;
            this.activeTab = 0;
            this.dialog = true;
        },
        async verificarCliente(codigo) {
            return (await axios.get("api/Clientes/Verificar/" + codigo)).data;
        },
        async crearCliente() {
            if (this.validarFormulario()) {
                if ((await this.verificarCliente(this.codigo)) == "200") {
                    this.snackbar_text = this.$t("customer-message2") + " " + this.codigo;
                    this.snackbar = true;
                    return;
                }

                axios
                    .post("api/Clientes/Crear", {
                        id_tipo_doc_fiscal: this.id_tipo_doc_fiscal,
                        id_departamento: this.id_departamento,
                        id_municipio: this.id_municipio,
                        id_identificador: this.id_identificador,
                        id_pais: this.id_pais,
                        id_tipo_exportacion: this.id_tipo_exportacion,
                        id_empresa: this.$store.state.emp.id_empresa,
                        fecha_ingreso: this.fecha_ingreso,
                        codigo: this.codigo,
                        nombre: this.nombre,
                        razon_social: this.razon_social,
                        direccion: this.direccion,
                        id_actividad_economica: this.id_actividad_economica,
                        tamaño: this.tamaño,
                        registro: this.registro,
                        correo_1: this.email_1,
                        correo_2: this.email_2,
                        contacto: this.contacto,
                        telefono: this.telefono,
                        tipo_persona: this.tipo_persona,
                        documento: this.documento.trim(),
                        con_retencion: this.con_retencion,
                        cliente_activo: this.cliente_activo,
                        cliente_x: this.cliente_x,
                        exento: this.exento,
                        con_percecion: this.con_percepcion,
                        con_credito: this.con_credito,
                        exede_credito: this.exede_credito,
                        limite_credito: this.limite_credito,
                        max_dias_limite: this.maximo_dias_limite,
                        extranjero: this.extranjero,
                        zona_franca_dpa: this.es_zona_franca_dpa,
                        pacientes: this.items_pacientes || [],
                        crearContratoCliente: this.items_contratos,
                    })
                    .then(() => {
                        this.snackbar_text = this.$t("customer-message3");
                        this.snackbar = true;
                        this.cerrarDialogCliente();
                        this.listarClientes();
                    })
                    .catch(() => {
                        this.snackbar_text = this.$t("customer-message4");
                        this.snackbar = true;
                    });
            }
        },
        editarCliente(item) {
            if (!item) return;

            this.id_cliente = item.id_cliente ?? 0;
            this.id_empresa = item.id_empresa ?? 0;
            this.fecha_ingreso = settings.metodos.formatoFecha(item.fecha_ingreso ?? new Date());
            this.id_tipo_doc_fiscal = item.id_tipo_doc_fiscal ?? "";
            this.codigo = item.codigo ?? "";
            this.nombre = item.nombre ?? "";
            this.razon_social = item.razon_social ?? "";
            this.id_departamento = item.id_departamento ?? "";
            this.id_municipio = item.id_municipio ?? "";
            this.direccion = item.direccion ?? "";
            this.id_actividad_economica = item.id_actividad_economica ?? "";
            this.tamaño = item.tamaño ?? "";
            this.registro = item.registro ?? "";
            this.email_1 = item.correo_1 ?? "";
            this.email_2 = item.correo_2 ?? "";
            this.contacto = item.contacto ?? "";
            this.telefono = item.telefono ?? "";
            this.tipo_persona = item.tipo_persona ?? "";
            this.id_identificador = item.id_identificador ?? "";
            this.documento = item.documento ?? "";
            this.con_retencion = !!item.con_retencion;
            this.con_percepcion = !!item.con_percepcion;
            this.cliente_activo = !!item.cliente_activo;
            this.cliente_x = !!item.cliente_x;
            this.exento = !!item.exento;
            this.con_credito = !!item.con_credito;
            this.exede_credito = !!item.exede_credito;
            this.limite_credito = item.limite_credito ?? "";
            this.maximo_dias_limite = item.max_dias_limite ?? "";
            this.extranjero = !!item.extranjero;
            this.id_tipo_exportacion = item.id_tipo_exportacion ?? "";
            this.es_zona_franca_dpa = !!item.zona_franca_dpa;
            this.id_pais = item.id_pais ?? "";

            this.listarMunicipios(this.id_departamento).then(() => {
            });
            this.listarPaises("edit");
            this.listarContratoCliente(this.id_cliente);

            this.activeTab = 0;
            this.flag_nuevo_edit = 2;
            this.$emit("update:estado_dialog", true);

        },
        actualizarCliente() {
            //if (this.validarFormulario()) {
            axios
                .put("api/Clientes/Actualizar", {
                    id_cliente: this.id_cliente,
                    id_tipo_doc_fiscal: this.id_tipo_doc_fiscal,
                    id_departamento: this.id_departamento,
                    id_municipio: this.id_municipio,
                    id_identificador: this.id_identificador,
                    id_pais: this.id_pais,
                    id_tipo_exportacion: this.id_tipo_exportacion,
                    id_empresa: this.id_empresa,
                    fecha_ingreso: this.fecha_ingreso,
                    codigo: this.codigo,
                    nombre: this.nombre,
                    razon_social: this.razon_social,
                    direccion: this.direccion,
                    id_actividad_economica: this.id_actividad_economica,
                    tamaño: this.tamaño,
                    registro: this.registro,
                    correo_1: this.email_1,
                    correo_2: this.email_2,
                    contacto: this.contacto,
                    telefono: this.telefono,
                    tipo_persona: this.tipo_persona,
                    documento: this.documento,
                    con_retencion: this.con_retencion,
                    con_percepcion: this.con_percepcion,
                    cliente_activo: this.cliente_activo,
                    cliente_x: this.cliente_x,
                    exento: this.exento,
                    con_credito: this.con_credito,
                    exede_credito: this.exede_credito,
                    limite_credito: this.limite_credito,
                    max_dias_limite: this.maximo_dias_limite,
                    extranjero: this.extranjero,
                    zona_franca_dpa: this.es_zona_franca_dpa,
                    pacientes: this.items_pacientes || [],
                    actualizarContratoCliente: this.items_contratos.map((contrato) => ({
                        id_contrato_cliente: contrato.id_contrato_cliente,
                        id_cliente: this.id_cliente,

                        fecha_contrato: contrato.fecha_contrato,
                        fecha_caducidad: contrato.fecha_caducidad,
                        codigo_bien: contrato.codigo_bien,
                        cautelado_contrato: contrato.cautelado_contrato,
                        extingido_contrato: contrato.extingido_contrato,
                        contrato_descripcion: contrato.contrato_descripcion,
                        monto_contrato: contrato.monto_contrato,
                        contrato_activo: contrato.contrato_activo,
                        numero_contrato: contrato.numero_contrato,
                    })),
                })
                .then(() => {
                    this.snackbar_text = this.$t("customer-message5");
                    this.snackbar = true;
                    this.cerrarDialogCliente();
                    this.listarClientes();
                })
                .catch(() => {
                    this.snackbar_text = this.$t("customer-message6");
                    this.snackbar = true;
                });
            //}
        },
        cerrarDialogCliente() {
            this.$emit("update:estado_dialog", !this.estado_dialog);
            this.limpiarCliente();
        },
        limpiarCliente() {
            this.fecha_ingreso = this.fecha_ingreso;
            this.id_tipo_doc_fiscal = "";
            this.codigo = "";
            this.nombre = "";
            this.razon_social = "";
            this.id_departamento = "";
            this.id_municipio = "";
            this.direccion = "";
            this.id_actividad_economica = "";
            this.tamaño = "";
            this.registro = "";
            this.email_1 = "";
            this.email_2 = "";
            this.contacto = "";
            this.telefono = "";
            this.tipo_persona = "";
            this.id_identificador = "";
            this.documento = "";
            this.con_retencion = false;
            this.cliente_activo = true;
            this.cliente_x = false;
            this.exento = false;
            this.con_percepcion = "";
            this.con_credito = false;
            this.exede_credito = false;
            this.limite_credito = "";
            this.maximo_dias_limite = "";
            this.extranjero = false;
            this.id_tipo_exportacion = "";
            this.es_zona_franca_dpa = false;
            this.id_pais = "";
            this.id_empresa = 0;

            //contratos
            this.fecha_contrato = settings.metodos.formatoFecha(new Date());
            this.codigo_bien = "";
            this.contrato_descripcion = "";
            this.monto_contrato = 0.0;
            this.cautelado_contrato = false;
            this.extingido_contrato = false;
            this.fecha_caducidad = settings.metodos.formatoFecha(new Date());
            this.numero_contrato = "";
            this.contrato_activo = false;

            //errores
            this.errorCodigo = false;
            this.errorNombre = false;
            this.errorTipoDocFiscal = false;
            this.errorRazonSocial = false;
            this.errorDepartamento = false;
            this.errorMunicipio = false;
            this.errorDireccion = false;
            this.errorActividadEconomica = false;
            this.errorTamaño = false;
            this.errorTelefono = false;
            this.errorTipoPersona = false;
            this.errorIdentificador = false;
            this.errorDocumento = false;
            this.errorPais = false;
            this.errorTipoExportacion = false;
            this.items_pacientes = [];


        },
        async listarDepartamentos() {
            this.items_departamento = await (
                await settings.metodos.Departamentos()
            ).data;
        },
        async listarMunicipios(item) {
            var departamento = await (await settings.metodos.Departamento(item)).data;

            this.items_municipio = await (
                await settings.metodos.Municipios(departamento.cod_depa)
            ).data;
        },
        async listarPaises(status) {
            this.items_paises = await (await settings.metodos.Paises()).data;
        },
        setPais(event, { item }) {
            this.id_pais = item.id_pais;
            this.dialog_paises = false;
        },
        async listarIdentificadores() {
            this.items_identificador = await (
                await settings.metodos.Identificador()
            ).data;
        },
        async listarTipoDocFiscales() {
            this.items_tipo_doc_fiscal = await (
                await settings.metodos.TipoDocFiscal()
            ).data;
        },
        async listarTipoExportacion() {
            this.items_tipo_export = await (
                await settings.metodos.TipoExportacion()
            ).data;
        },
        formatoFecha(fecha) {
            return moment(fecha).format("YYYY-MM-dd");
        },
        estadoRetencion() {
            this.con_percepcion = false;
        },
        estadoPercepcion() {
            this.con_retencion = false;
        },
        seleccionExtranjero() {
            if (this.extranjero) {
                this.con_retencion = false;
                this.con_percepcion = false;
                this.exento = false;
            }
        },
        seleccionExento() {
            if (this.extranjero) {
                this.extranjero = false;
            }
        },
        validarFormulario() {
            let isValid = false;
            if (this.id_tipo_doc_fiscal === 11) {
                //FAC
                if (
                    !this.codigo ||
                    !this.nombre ||
                    !this.id_tipo_doc_fiscal ||
                    !this.id_departamento ||
                    !this.id_municipio ||
                    !this.direccion ||
                    !this.email_1 ||
                    !this.telefono ||
                    !this.id_identificador ||
                    !this.documento
                ) {
                    this.errorCodigo = this.codigo == "" ? true : false;
                    this.errorNombre = this.nombre == "" ? true : false;
                    this.errorTipoDocFiscal =
                        this.id_tipo_doc_fiscal == "" ? true : false;
                    this.errorDepartamento = this.id_departamento == "" ? true : false;
                    this.errorMunicipio = this.id_municipio == "" ? true : false;
                    this.errorDireccion = this.direccion == "" ? true : false;
                    this.errorEmail1 = this.email_1 == "" ? true : false;
                    this.errorTelefono = this.telefono == "" ? true : false;
                    this.errorIdentificador = this.id_identificador == "" ? true : false;
                    this.errorDocumento = this.documento == "" ? true : false;
                } else {
                    isValid = true;
                }
            } else if (
                this.id_tipo_doc_fiscal == 10 ||
                this.id_tipo_doc_fiscal == 13 ||
                this.id_tipo_doc_fiscal == 15
            ) {
                //CCF, NCR, NRM
                if (
                    !this.codigo ||
                    !this.nombre ||
                    !this.id_tipo_doc_fiscal ||
                    !this.razon_social ||
                    !this.id_departamento ||
                    !this.id_municipio ||
                    !this.direccion ||
                    !this.tamaño ||
                    !this.registro ||
                    !this.email_1 ||
                    !this.telefono ||
                    !this.id_identificador ||
                    !this.documento ||
                    !this.tipo_persona ||
                    !this.id_actividad_economica
                ) {
                    this.errorCodigo = this.codigo == "" ? true : false;
                    this.errorNombre = this.nombre == "" ? true : false;
                    this.errorTipoDocFiscal =
                        this.id_tipo_doc_fiscal == "" ? true : false;
                    this.errorRazonSocial = this.razon_social == "" ? true : false;
                    this.errorDepartamento = this.id_departamento == "" ? true : false;
                    this.errorMunicipio = this.id_municipio == "" ? true : false;
                    this.errorDireccion = this.direccion == "" ? true : false;
                    this.errorTamaño = this.tamaño == "" ? true : false;
                    this.errorRegistro = this.registro == "" ? true : false;
                    this.errorEmail1 = this.email_1 == "" ? true : false;
                    this.errorTelefono = this.telefono == "" ? true : false;
                    this.errorIdentificador = this.id_identificador == "" ? true : false;
                    this.errorDocumento = this.documento == "" ? true : false;
                    this.errorTipoPersona = this.errorTipoPersona == "" ? true : false;
                    this.errorActividadEconomica =
                        this.id_actividad_economica == "" ? true : false;
                } else {
                    isValid = true;
                }
            } else if (this.id_tipo_doc_fiscal === 12) {
                //FEX
                if (
                    !this.codigo ||
                    !this.nombre ||
                    !this.id_tipo_doc_fiscal ||
                    !this.direccion ||
                    !this.email_1 ||
                    !this.telefono ||
                    !this.id_identificador ||
                    !this.documento ||
                    !this.id_actividad_economica ||
                    !this.id_tipo_exportacion ||
                    !this.id_pais
                ) {
                    this.errorCodigo = this.codigo == "" ? true : false;
                    this.errorNombre = this.nombre == "" ? true : false;
                    this.errorTipoDocFiscal =
                        this.id_tipo_doc_fiscal == "" ? true : false;
                    this.errorDireccion = this.direccion == "" ? true : false;
                    this.errorEmail1 = this.email_1 == "" ? true : false;
                    this.errorTelefono = this.telefono == "" ? true : false;
                    this.errorIdentificador = this.id_identificador == "" ? true : false;
                    this.errorDocumento = this.documento == "" ? true : false;
                    this.errorActividadEconomica =
                        this.id_actividad_economica == "" ? true : false;
                    this.errorTipoExportacion =
                        this.id_tipo_exportacion == "" ? true : false;
                    this.errorPais = this.id_pais == "" ? true : false;
                } else {
                    isValid = true;
                }
            } else {
                this.errorTipoDocFiscal =
                    this.id_tipo_doc_fiscal == null ? false : true;
            }

            return isValid;
        },
        eliminarCliente() {
            this.dialog_eliminar_cliente = true;
        },
        confirmarEliminarCliente() {
            axios
                .delete("api/Clientes/Eliminar/" + this.id_cliente)
                .then((response) => {
                    if (response.data == 400) {
                        this.snackbar_text = this.$t("customer-message7");
                        this.snackbar = true;
                        return;
                    }
                    this.dialog_eliminar_cliente = false;
                    this.dialog = false;
                    this.listarClientes();
                    this.snackbar_text = this.$t("customer-message8");
                    this.snackbar = true;
                })
                .catch(() => {
                    this.snackbar_text = this.$t("customer-message9");
                    this.snackbar = true;
                });
        },

        //Contratos-Codigo de bien

        listarContratoCliente(id_cliente) {
            axios.get("api/ContratoCliente/Listar/" + id_cliente).then((response) => {
                if (Array.isArray(response.data)) {
                    this.items_contratos = response.data;
                } else {
                    console.error("Respuesta no esperada:", response.data);
                    this.items_contratos = [];

                    this.snackbar = true;
                }
            })
                .catch((error) => {
                    console.error("Error al listar los contratos:", error);
                    this.snackbar_text = "No se pudieron cargar los contratos";
                    this.snackbar = true;
                });
        },

        agregarContrato() {
            if (this.id_cliente) {
                if (this.id_contrato_cliente) {
                    this.actualizarContratoCliente();
                } else {
                    this.crearContratoCliente();
                }
            } else {
                this.items_contratos.push({
                    fecha_contrato: this.fecha_contrato,
                    fecha_caducidad: this.fecha_caducidad,
                    codigo_bien: this.codigo_bien,
                    extingido_contrato: this.extingido_contrato,
                    cautelado_contrato: this.cautelado_contrato,
                    contrato_descripcion: this.contrato_descripcion,
                    monto_contrato: this.monto_contrato,
                    numero_contrato: this.numero_contrato,
                    contrato_activo: this.contrato_activo,
                });

                this.fecha_contrato = settings.metodos.formatoFecha(new Date());
                this.fecha_caducidad = settings.metodos.formatoFecha(new Date());
                this.codigo_bien = "";
                this.extingido_contrato = false;
                this.cautelado_contrato = false;
                this.contrato_descripcion = "";
                this.monto_contrato = 0.0;
                this.numero_contrato = "";
                this.contrato_activo = true;
            }
        },
        crearContratoCliente() {
            axios
                .post("api/ContratoCliente/Crear", {
                    id_cliente: this.id_cliente,
                    fecha_contrato: this.fecha_contrato,
                    fecha_caducidad: this.fecha_caducidad,
                    extingido_contrato: this.extingido_contrato,
                    cautelado_contrato: this.cautelado_contrato,
                    codigo_bien: this.codigo_bien,
                    contrato_descripcion: this.contrato_descripcion,
                    monto_contrato: this.monto_contrato,
                    contrato_activo: this.contrato_activo,
                    numero_contrato: this.numero_contrato,
                })
                .then(() => {
                    this.fecha_contrato = settings.metodos.formatoFecha(new Date());
                    this.fecha_caducidad = settings.metodos.formatoFecha(new Date());
                    this.extingido_contrato = false;
                    this.cautelado_contrato = false;
                    this.codigo_bien = "";
                    this.contrato_descripcion = "";
                    this.monto_contrato = 0.0;
                    this.listarContratoCliente(this.id_cliente);
                })
                .catch(() => {
                    this.snackbar_text = "No se pudo anexar el contrato";
                    this.snackbar = true;
                });
        },
        actualizarContratoCliente() {
            axios
                .put("api/ContratoCliente/Actualizar", {
                    id_contrato_cliente: this.id_contrato_cliente,
                    id_cliente: this.id_cliente,

                    fecha_contrato: this.fecha_contrato,
                    fecha_caducidad: this.fecha_caducidad,
                    extingido_contrato: this.extingido_contrato,
                    cautelado_contrato: this.cautelado_contrato,
                    codigo_bien: this.codigo_bien,
                    contrato_descripcion: this.contrato_descripcion,
                    monto_contrato: this.monto_contrato,
                    contrato_activo: this.contrato_activo,
                    numero_contrato: this.numero_contrato,
                })
                .then(() => {
                    this.id_contrato_cliente = "";
                    this.id_cliente = "";
                    this.fecha_contrato = settings.metodos.formatoFecha(new Date());
                    this.fecha_caducidad = settings.metodos.formatoFecha(new Date());
                    this.extingido_contrato = false;
                    this.cautelado_contrato = false;
                    this.codigo_bien = "";
                    this.contrato_descripcion = "";
                    this.monto_contrato = 0.0;
                    this.numero_contrato = "";
                    this.contrato_activo = true;

                    this.listarContratoCliente(this.id_cliente);
                    this.snackbar_text = "Contrato actualizado con éxito";
                    this.snackbar = true;
                    this.dialog_compras = false;

                })
                .catch(() => {
                    this.snackbar_text = "No se pudo actualizar el contrato";
                    this.snackbar = true;
                });
        },
        editarContrato(item) {
            this.id_cliente = item.id_cliente;
            this.id_contrato_cliente = item.id_contrato_cliente;
            this.fecha_contrato = item.fecha_contrato;
            this.fecha_caducidad = item.fecha_caducidad;
            this.extingido_contrato = item.extingido_contrato;
            this.cautelado_contrato = item.cautelado_contrato;
            this.monto_contrato = item.monto_contrato;
            this.codigo_bien = item.codigo_bien;
            this.contrato_descripcion = item.contrato_descripcion;
            this.numero_contrato = item.numero_contrato;
            this.contrato_activo = item.contrato_activo;
        },
        removerContrato(item) {
            if (item.id_contrato_cliente > 0) {
                this.id_contrato_cliente = item.id_contrato_cliente;
                this.dialog_eliminar_contrato = true;
            } else {
                var index = this.items_contratos.findIndex(
                    (x) => x.id_contrato_cliente == item.id_contrato_cliente
                );
                this.items_contratos.splice(index, 1);
            }
        },
        eliminarProductoDetalle() {
            axios
                .delete("api/DetalleContrato/Eliminar/" + this.id_detalle_cliente)
                .then(() => {
                    this.dialog_eliminar_contrato = false;
                    his.listarContratoCliente(this.id_cliente);
                    this.snackbar_text = "El registro se elimino con exito";
                    this.snackbar = true;
                })
                .catch(() => {
                    this.snackbar_text = "No se pudo eliminar el registro";
                    this.snackbar = true;
                });
        },
        async generarReporteNPE() {
            try {
                // Toma todos los contratos existentes del cliente actual
                const ids = this.items_contratos
                    .filter(c => c.id_contrato_cliente)
                    .map(c => c.id_contrato_cliente);

                if (!ids.length) {
                    this.snackbar_text = "No hay contratos para generar reporte.";
                    this.snackbar = true;
                    return;
                }

                const payload = {
                    id_contrato_cliente: ids,
                    tipo_doc: "pdf",
                    server: "LOCAL"
                };

                const resp = await axios.post("api/Clientes/NPE", payload);
                const pdfUrl = resp.data;

                // Descargar el PDF
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.setAttribute('download', 'Reporte_NPE.pdf');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.snackbar_text = "Reporte NPE generado correctamente.";
                this.snackbar = true;
            } catch (e) {
                console.error(e);
                this.snackbar_text = "Error al generar el reporte NPE.";
                this.snackbar = true;
            }
        },
        ReporteNPE() {
            if (this.$store.state.emp.id_empresa) {
                this.loading_facturas = true;
                axios.get("api/Clientes/Listar/" + this.$store.state.emp.id_empresa)
                    .then((response) => {
                        if (Array.isArray(response.data)) {
                            const retData = response.data.filter(item => {
                                const contrato = new this.id_contrato_cliente;
                                const cliente = this.id_cliente;


                            }).map(item => {
                                const cliente = this.item.id_contrato_cliente;
                                return item;
                            });

                            // Obtener los IDs de facturas
                            const id_contrato_cliente = retData.map(item => item.id_contrato_cliente);

                            if (id_.length > 0) {
                                // Crear los parámetros para la solicitud
                                const parametros = {
                                    id_facturas: id_factura,
                                    tipo_doc: "pdf", // Tipo Doc
                                    server: "LOCAL" // LOCAL o SERVER
                                };

                                axios.post("api/Clientes/NPE", parametros)
                                    .then(response => {
                                        const reporteURL = response.data;

                                        // Descargar el archivo PDF
                                        const link = document.createElement('a');
                                        link.href = reporteURL;
                                        link.setAttribute('download', `Reportes_NPE_${this.anio}_${this.mes}.pdf`);
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);

                                        this.base64_doc = "data:application/pdf;base64," + response.data;
                                        this.dialog_preview_report = true;

                                        this.snackbar_text = "Reporte generado exitosamente";
                                        this.snackbar = true;
                                    })
                                    .catch(error => {
                                        this.snackbar_text = "No se pudo generar el reporte de Retención";
                                        this.snackbar = true;
                                    })
                                    .finally(() => {
                                        this.loading_facturas = false;
                                    });

                            } else {
                                //console.warn("No hay documentos para el año y mes seleccionados");
                                this.snackbar_text = "No hay documentos con Retención para el año y mes seleccionados";
                                this.snackbar = true;
                                this.loading_facturas = false;
                            }
                        } else {
                            this.snackbar_text = "Error en la respuesta del servidor";
                            this.snackbar = true;
                            this.loading_facturas = false;
                        }
                    })
                    .catch(error => {
                        this.snackbar_text = "No se pudo descargar el archivo de Retención";
                        this.snackbar = true;
                        this.loading_facturas = false;
                    });
            } else {
                console.error("El id_empresa es undefined");
            }
        },
        cerrarDialogCliente() {
            this.$emit("update:estado_dialog", !this.estado_dialog);
            this.limpiarCliente();
        },



    },
};
</script>

<style>
.borde {
    border: 1px solid black;
    margin-top: 5px;
    margin-bottom: 5px;
}
</style>